/**
 * box
 */

// import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_box.scss';
import './_box--contact.scss';

// Module template
import './_box.twig';
import './_box--contact.twig';
import './_box--icon.twig';
import './_box--facts.twig';
import './_box--two-column.twig';
import './_box--two-row.twig';
import './_box--hero.twig';
import './_box--contact-flipcard.twig';

export const name = 'box';

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 */
// eslint-disable-next-line no-unused-vars
export function disable($context) {}

/**
 * Each component has a chance to run when its enable function is called.
 *
 * @param {jQuery} $context - A piece of DOM
 */
// eslint-disable-next-line no-unused-vars
export function enable($context) {}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};